import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card";
import Button from "../components/Button";
import API from "../api/api";

export default function OfertasRecibidas() {
  const nav = useNavigate();
  const [publicaciones, setPublicaciones] = useState([]);
  const [loading, setLoading] = useState(true);

  const guardarOperacionId = (ofertaId, operacionId) => {
    if (!ofertaId || !operacionId) return;
    try {
      const raw = localStorage.getItem("ofertaOperacionMap");
      const map = raw ? JSON.parse(raw) : {};
      map[String(ofertaId)] = operacionId;
      localStorage.setItem("ofertaOperacionMap", JSON.stringify(map));
    } catch (err) {
      console.error("Error guardando operacionId en storage:", err);
    }
  };



  // GET /publicaciones/


  const cargarDatos = async () => {
    try {
      const resPub = await API.get("/publicaciones/");
      const pubs = resPub.data;

      // agregar ofertas a cada pub
      const pubsConDatos = await Promise.all(
        pubs.map(async (pub) => {
          const resOfertas = await API.get(`/ofertas/publicacion/${pub.id}/`);

          return {
            ...pub,
            ofertas: resOfertas.data,
            compradoresBloqueados: pub.compradores_bloqueados || [],
          };
        })
      );

      setPublicaciones(pubsConDatos);
    } catch (err) {
      console.error("Error cargando publicaciones", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);


  // ACEPTAR OFERTA
  // POST /ofertas/<id>/aceptar/

  const aceptarOferta = async (pubId, ofertaId) => {
    try {
      const res = await API.post(`/ofertas/${ofertaId}/aceptar/`);
      const operacionId = res?.data?.id || res?.data?.chat_id;
      guardarOperacionId(ofertaId, operacionId);

      setPublicaciones((prev) =>
        prev.map((pub) =>
          pub.id === pubId
            ? {
              ...pub,
              estado: "pendiente",
              ofertas: pub.ofertas.map((of) =>
                of.id === ofertaId
                  ? { ...of, estado: "aceptada", operacion_id: operacionId }
                  : { ...of, estado: "rechazada" }
              ),
            }
            : pub
        )
      );

      const correoEnviado = Boolean(res?.data?.email_enviado);
      alert(
        correoEnviado
          ? "Oferta aceptada. Se creó la operación, el chat y el correo fue enviado al deudor."
          : "Oferta aceptada. Se creó la operación y el chat."
      );
    } catch (err) {
      console.error("Error aceptando oferta", err);
      alert("Error al aceptar la oferta.");
    }
  };

  if (loading)
    return (
      <p className="text-center text-primary mt-10">
        Cargando ofertas recibidas...
      </p>
    );

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-primary">Ofertas recibidas</h1>
      <p className="text-slate-600">Seleccione una oferta para iniciar la operación.</p>

      {publicaciones.length === 0 ? (
        <p className="text-slate-500">No tienes publicaciones activas.</p>
      ) : (
        <div className="space-y-6">
          {publicaciones.map((pub) => (
            <Card key={pub.id} className="space-y-4">
              {/* CABECERA */}
              <div>
                <h2 className="text-lg font-semibold text-primary">{pub.titulo}</h2>
                <p className="text-sm text-slate-600 capitalize">
                  Tipo: {pub.tipo} — Monto:{" "}
                  <b className="text-primary">
                    {Number(pub.monto).toLocaleString("es-PY")} Gs
                  </b>
                </p>
              </div>

              {/* OFERTAS */}
              <div className="space-y-4">
                <h3 className="font-semibold text-primary text-sm">Ofertas recibidas</h3>

                {pub.ofertas.length === 0 ? (
                  <p className="text-slate-500 text-sm">
                    No hay ofertas para esta publicación aún.
                  </p>
                ) : (
                  pub.ofertas.map((oferta) => {
                    const bloqueado = pub.compradoresBloqueados.includes(oferta.comprador);

                    return (
                      <div key={oferta.id} className="border rounded p-3 bg-slate-50">
                        <div className="flex justify-between">
                          <div>
                            <p className="font-semibold">
                              {Number(oferta.monto).toLocaleString("es-PY")} Gs
                            </p>

                            <p className="text-xs text-slate-600">
                              {new Date(oferta.fecha).toLocaleString()}
                            </p>

                            {bloqueado && (
                              <span className="text-red-600 text-xs font-semibold">
                                * Comprador bloqueado — no puede ser aceptado
                              </span>
                            )}
                          </div>

                          {/* BOTÓN ACEPTAR */}
                          {!bloqueado && oferta.estado === "enviada" && (
                            <Button
                              className="bg-primary text-white"
                              onClick={() => aceptarOferta(pub.id, oferta.id)}
                            >
                              Aceptar
                            </Button>
                          )}
                        </div>

                        {/* Estado visual */}
                        {oferta.estado !== "enviada" && (
                          <div className="mt-3">
                            <p
                              className={`text-xs font-semibold ${oferta.estado === "aceptada"
                                ? "text-emerald-600"
                                : "text-red-600"
                                }`}
                            >
                              {oferta.estado === "aceptada"
                                ? "Oferta aceptada"
                                : "Oferta rechazada"}
                            </p>

                            {/* Botón para ir al chat si está aceptada */}
                            {oferta.estado === "aceptada" && (
                              <Button
                                className="!bg-accent !text-black mt-2"
                                onClick={() => {

                                  if (!oferta.operacion_id) return;
                                  nav("/chat-operacion", {
                                    state: { operacionId: oferta.operacion_id }
                                  });
                                }}
                              >
                                💬 Ir al chat
                              </Button>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
